var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7057 0H17.5913H23.4768V6.01635H17.5913H11.7057H5.88556V12.0327V12.4251V18.049V18.1144V24.0654H0V18.1144V18.049V12.4251V12.0327V6.01635V0H5.88556H11.7057ZM17.5913 17.9837H11.7711V12.0327H23.4768V18.2452C23.4768 19.8147 22.8883 21.2534 21.842 22.3651C20.7956 23.4768 19.3569 24.0654 17.8529 24.0654H17.6567V17.9837H17.5913Z",
    fill: "#6851FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4768,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortmatic);
export default __webpack_public_path__ + "static/media/fortmatic.80dc9c911e48bb2d1e9135801dfccce6.svg";
export { ForwardRef as ReactComponent };